module.exports = __webpack_public_path__ + "img/BKX.63248461.svg";